import React from "react";

const TrendingSearches = () => {
    const items = [
        {
            title: "Salons",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10418299.jpg?w=256&q=75",
            link: "#",
        },
        {
            title: "Lawyers For Criminal",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10296153.jpg?w=256&q=75",
            link: "#",
        },
        {
            title: "Schools",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10422444.jpg?w=256&q=75",
            link: "#",
        },
        {
            title: "CBSE Schools",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10083838.jpg?w=256&q=75",
            link: "#",
        },
        {
            title: "Dance Classes",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10152976.jpg?w=256&q=75",
            link: "#",
        },
        {
            title: "Cricket Coaching Classes",
            img: "https://content.jdmagicbox.com/comp/def_content/ncat_id/10147469.jpg?w=256&q=75",
            link: "#",
        },
    ];

    return (
        <div className="container my-5">
            <h2 className="fw-bold text-dark mb-1">
                Trending Searches Near You
                <span className="badge bg-danger ms-2">NEW</span>
            </h2>
            <p className="text-muted mb-4">Stay updated with the latest local trends.</p>

            <div className="row g-3">
                {items.map((item, index) => (
                    <div key={index} className="col-6 col-md-4 col-lg-4">
                        <a
                            href={item.link}
                            className="text-decoration-none d-block border rounded shadow-sm bg-white"
                        >
                            <div style={{ height: "120px", overflow: "hidden" }}>
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-100 h-100"
                                    style={{ objectFit: "cover" }}
                                />
                            </div>
                            <div className="p-2">
                                <h6 className="fw-bold text-dark mb-1" style={{ height: "40px" }}>
                                    {item.title}
                                </h6>
                                <div className="text-primary fw-semibold small">Explore →</div>
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TrendingSearches;
